import { render, staticRenderFns } from "./Thead.vue?vue&type=template&id=21a486b1&scoped=true&"
import script from "./Thead.vue?vue&type=script&lang=js&"
export * from "./Thead.vue?vue&type=script&lang=js&"
import style0 from "./Thead.vue?vue&type=style&index=0&id=21a486b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a486b1",
  null
  
)

export default component.exports